module.exports = __webpack_public_path__ + "imgs/user.34c753803d26f5c8b5215c73aadc0659.svg";